import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

export default function Event() {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20event%20reception%20hall%20decorated%20with%20tall%20floral%20centerpieces%2C%20candles%2C%20and%20greenery%20garlands%2C%20warm%20ambient%20lighting%2C%20white%20and%20blush%20pink%20roses%2C%20round%20tables%20with%20white%20linen%2C%20celebratory%20atmosphere%2C%20editorial%20event%20photography&width=1600&height=900&seq=event-hero-001&orientation=landscape"
            alt="Event- & Firmenfloristik – Elegante Raumdekoration mit Blumen und Kerzen"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg">
            Event- & Firmenfloristik
          </h1>
          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed drop-shadow-md">
            Florale Gestaltung schafft Atmosphäre. Für private Feiern und geschäftliche Anlässe entwickeln wir individuelle Konzepte, die Räume und Menschen miteinander verbinden.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-background-50 text-foreground-950 rounded-md text-sm font-medium hover:bg-white transition-colors whitespace-nowrap shadow-lg"
            >
              Florales Konzept anfragen
            </Link>
            <a
              href="https://www.fleurop.de/partnerfloristen/fleurop-filialen/26789-leer/florale-manufaktur-blumen-stoehr-gmbh-heisfelder-str-105"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/80 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center mr-2"></i>
              Blumen online über Fleurop versenden
            </a>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <main>
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6">
            Besondere Anlässe, besondere Floristik
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-10">
            Ob Firmenevent, Geburtstagsfeier oder Jubiläum – wir gestalten florale Konzepte, die Ihre Veranstaltung unvergesslich machen. Von der ersten Idee bis zur Umsetzung vor Ort begleiten wir Sie professionell und kreativ.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {[
              { icon: "ri-cake-3-line", title: "Geburtstage und Jubiläen", desc: "Persönliche Blumendekoration für Ihre Feier" },
              { icon: "ri-goblet-line", title: "Veranstaltungen und Empfänge", desc: "Elegante Raumgestaltung für Events jeder Größe" },
              { icon: "ri-building-4-line", title: "Empfangs- und Geschäftsräume", desc: "Wöchentliche Blumenarrangements für Ihr Büro" },
              { icon: "ri-plant-line", title: "Innenraumbegrünung", desc: "Grüne Akzente für ein angenehmes Arbeitsklima" },
              { icon: "ri-briefcase-line", title: "Florale Dekorationen für Unternehmen", desc: "Individuelle Konzepte für Ihr Firmenimage" },
              { icon: "ri-gift-2-line", title: "Mitarbeiter- und Kundengeschenke", desc: "Hochwertige Blumengeschenke für besondere Momente" },
              { icon: "ri-calendar-event-line", title: "Regelmäßige Blumenarrangements", desc: "Abgestimmt auf Ihren Raum und Ihre Wünsche" },
            ].map((item) => (
              <div
                key={item.title}
                className="flex items-start gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200/70"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-primary-600`}></i>
                </div>
                <div>
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Unverbindliches Angebot anfragen
            </Link>
          </div>
        </div>
      </main>

      <Footer />
      <MobileBottomBar />
    </>
  );
}